"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialIcons = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SocialIcon_atom_1 = require("../atoms/SocialIcon.atom");
const Styled = styled_components_1.default.div `
	/* Move icons over for the padding of one side of the icon to line up on the left */
	margin-left: -6px;
	font-size: 18px;
`;
const SocialIcons = ({ socialLinks = [] }) => {
    return (react_1.default.createElement(Styled, { className: "social-icons" }, socialLinks.map((socialLink) => {
        if (!socialLink.id)
            return null;
        return react_1.default.createElement(SocialIcon_atom_1.SocialIcon, Object.assign({ key: socialLink.id }, socialLink));
    })));
};
exports.SocialIcons = SocialIcons;
//# sourceMappingURL=SocialIcons.molecule.js.map